<div *ngIf="specials.length > 0">
  <div class="d-flex justify-content-end mb-3">
    <div class="searchbar">
      <input
        class="search_input"
        type="text"
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchTextChange()"
        placeholder="Zoeken.."
      />
      <div class="search_icon"><i class="fas fa-search"></i></div>
    </div>
  </div>
  <table class="table table-hover fixed-table-layout">
    <thead>
      <tr>
        <th
          scope="col"
          class="width-3 p-0"
        >
          <button
            type="button"
            class="btn btn-primary"
            copySpecials
            [specials]="selectedSpecials"
            [disabled]="!selectedSpecials.length"
          >
            <i class="fa-solid fa-clipboard"></i>
          </button>
        </th>
        <th
          scope="col"
          class="width-10 sort"
          (click)="sortByField('sku', getNextAscending('sku'))"
        >
          <span>SKU</span>
          <div
            #sortIcons
            id="skuAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="skuDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="width-15 sort"
          (click)="sortByField('description', getNextAscending('description'))"
        >
          Omschrijving
          <div
            #sortIcons
            id="descriptionAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="descriptionDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="width-7 sort"
          (click)="sortByField('class2', getNextAscending('class2'))"
        >
          CL2
          <div
            #sortIcons
            id="class2Asc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="class2Desc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="width-10 sort"
          (click)="sortByField('supplierSku', getNextAscending('supplierSku'))"
        >
          <span>TU SKU</span>
          <div
            #sortIcons
            id="supplierSkuAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="supplierSkuDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="width-4 sort"
          (click)="sortByField('orderUnit', getNextAscending('orderUnit'))"
        >
          <span>MOQ</span>

          <div
            #sortIcons
            id="orderUnitAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="orderUnitDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="width-7 sort"
          (click)="sortByField('supplierPrice', getNextAscending('supplierPrice'))"
        >
          <span>Inkoop</span>
          <div
            #sortIcons
            id="supplierPriceAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="supplierPriceDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="width-7 sort"
          (click)="sortByField('salesPrice', getNextAscending('salesPrice'))"
        >
          <span>Verkoop</span>
          <div
            #sortIcons
            id="salesPriceAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="salesPriceDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="width-7 sort"
          (click)="sortByField('margin', getNextAscending('margin'))"
        >
          <span>Marge</span>
          <div
            #sortIcons
            id="marginAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="marginDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="width-10 sort"
          (click)="sortByField('creationBy', getNextAscending('creationBy'))"
        >
          <span>Door</span>
          <div
            #sortIcons
            id="creationByAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="creationByDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="width-10 sort"
          (click)="sortByField('creationDate', getNextAscending('creationDate'))"
        >
          <span>Op</span>
          <div
            #sortIcons
            id="creationDateAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="creationDateDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="
          let special of specials | searchTUSpecials: searchText | paginate: { itemsPerPage: 10, currentPage: page }
        "
      >
        <td>
          <input
            type="checkbox"
            class="form-check-input scale-1-5"
            [checked]="isSelected(special)"
            (change)="toggleSelection(special, $event)"
          />
        </td>
        <th scope="row">{{ special.sku }}</th>
        <td>{{ special.description }}</td>
        <td>{{ special.class2 }}</td>
        <td>{{ special.supplierSKU }}</td>
        <td class="text-end">{{ special.orderUnit }}</td>
        <td class="text-end text-nowrap">€{{ special.supplierPrice | smartRound: true }}</td>
        <td class="text-end text-nowrap">€{{ special.salesPrice | smartRound: true }}</td>
        <td class="text-end text-nowrap">{{ special.margin }}%</td>
        <td>{{ special.creationBy }}</td>
        <td>
          {{ special.creationDate! | utcDate: 'yyyy-MM-dd' }}
        </td>
      </tr>
    </tbody>
  </table>
  <pagination-controls
    (pageChange)="page = $event"
    previousLabel="Vorige"
    nextLabel="Volgende"
    [autoHide]="true"
  ></pagination-controls>
</div>
